import { blobticService } from '../../Commun/services/blobticService';

export interface Vehicle {
    id: number;
    uid: string;
    registrationNumber: string;
    brand: string;
    model: string;
    year: number;
    color?: string;
    fuelType: string;
    fuelTypeId?: number;
    transmission: string;
    mileage: number;
    status: string;
    driverId?: number;
    driverName?: string;
    proprietor?: string;
    proprietorId?: number;
    affectation?: string;
    affectationId?: number;
    dateAffectation?: Date;
    lastUpdate?: Date;
    userId?: number;
}

interface VehicleDto {
    VEH_IDF: number;
    VEH_UIDF: string;
    VEH_REGISTRATION: string;
    VEH_BRAND: string;
    VEH_MODEL: string;
    VEH_YEAR: number;
    VEH_COLOR?: string;
    VEH_FUEL_TYPE: string;
    FTP_IDF?: number;
    VEH_TRANSMISSION: string;
    VEH_MILEAGE: number;
    VEH_STATUS: string;
    DRV_IDF?: number;
    DRV_NAME?: string;
    VEH_PROPRIETAIRE?: string;
    PRP_IDF?: number;
    VEH_AFFECTATION?: string;
    AFF_IDF?: number;
    VEH_DATE_AFFECTATION?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: VehicleDto): Vehicle => ({
    id: dto.VEH_IDF,
    uid: dto.VEH_UIDF,
    registrationNumber: dto.VEH_REGISTRATION,
    brand: dto.VEH_BRAND,
    model: dto.VEH_MODEL,
    year: dto.VEH_YEAR,
    color: dto.VEH_COLOR,
    fuelType: dto.VEH_FUEL_TYPE,
    fuelTypeId: dto.FTP_IDF,
    transmission: dto.VEH_TRANSMISSION,
    mileage: dto.VEH_MILEAGE,
    status: dto.VEH_STATUS,
    driverId: dto.DRV_IDF,
    driverName: dto.DRV_NAME,
    proprietor: dto.VEH_PROPRIETAIRE,
    proprietorId: dto.PRP_IDF,
    affectation: dto.VEH_AFFECTATION,
    affectationId: dto.AFF_IDF,
    dateAffectation: dto.VEH_DATE_AFFECTATION ? new Date(dto.VEH_DATE_AFFECTATION) : undefined,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const vehiclesApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_vehicle,Select' }
        });
        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (data: Partial<Vehicle>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_vehicle,Insert',
            VEH_REGISTRATION: data.registrationNumber,
            VEH_BRAND: data.brand,
            VEH_MODEL: data.model,
            VEH_YEAR: data.year,
            VEH_COLOR: data.color,
            FTP_IDF: data.fuelTypeId,
            VEH_TRANSMISSION: data.transmission,
            VEH_MILEAGE: data.mileage || 0,
            VEH_STATUS: data.status || 'active',
            DRV_IDF: data.driverId,
            PRP_IDF: data.proprietorId,
            AFF_IDF: data.affectationId,
            VEH_DATE_AFFECTATION: data.dateAffectation?.toISOString()
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    update: async (id: number, data: Partial<Vehicle>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_vehicle,Update',
            VEH_IDF: id,
            VEH_REGISTRATION: data.registrationNumber,
            VEH_BRAND: data.brand,
            VEH_MODEL: data.model,
            VEH_YEAR: data.year,
            VEH_COLOR: data.color,
            FTP_IDF: data.fuelTypeId,
            VEH_TRANSMISSION: data.transmission,
            VEH_MILEAGE: data.mileage,
            VEH_STATUS: data.status,
            DRV_IDF: data.driverId,
            PRP_IDF: data.proprietorId,
            AFF_IDF: data.affectationId,
            VEH_DATE_AFFECTATION: data.dateAffectation?.toISOString()
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_vehicle,Delete', VEH_IDF: id }
        });
        return response;
    }
};
